import React from 'react';
import { Alert, Button } from '../ui';

interface Props {
  children: React.ReactNode;
  fallbackLabel?: string;
}

interface State {
  hasError: boolean;
  message: string | null;
}

class DashboardErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, message: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error.message };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    console.error('[DashboardErrorBoundary]', error, info.componentStack);
  }

  handleRetry = (): void => {
    this.setState({ hasError: false, message: null });
  };

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <Alert
          tone="error"
          title={this.props.fallbackLabel ?? 'No se pudo dibujar esta sección del dashboard.'}
          action={
            <Button variant="secondary" onClick={this.handleRetry}>
              Reintentar
            </Button>
          }
        >
          {this.state.message}
        </Alert>
      );
    }
    return this.props.children;
  }
}

export default DashboardErrorBoundary;
